(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 9544:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(1554);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
;// CONCATENATED MODULE: ./src/form/Label.tsx


function Label(param) {
    var id = param.id, label = param.label, required = param.required, className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
        htmlFor: id,
        className: (0,clsx_m/* default */.Z)('font-semibold', {
            "after:content-['*'] after:text-red-500": required
        }, className),
        children: label
    }));
};

;// CONCATENATED MODULE: ./src/form/Field.tsx



function Field(param) {
    var id = param.id, label = param.label, className = param.className, input = param.renderInput, required = param.required;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)('flex flex-col w-full relative', className),
        children: [
            input,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                id: id,
                required: required,
                label: label,
                className: "order-first"
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(3955);
;// CONCATENATED MODULE: ./src/form/Form.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Form(_param) {
    var useFormProps = _param.useFormProps, onSubmit = _param.onSubmit, children = _param.children, htmlProps = _objectWithoutProperties(_param, [
        "useFormProps",
        "onSubmit",
        "children"
    ]);
    var methods = (0,index_esm/* useForm */.cI)(useFormProps);
    var handleSubmit = methods.handleSubmit, reset = methods.reset;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, _objectSpread({}, methods, {
        /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", _objectSpread({
            onSubmit: handleSubmit(function(data) {
                onSubmit(data);
                reset();
            })
        }, htmlProps, {
            children: children
        }))
    })));
};

// EXTERNAL MODULE: ../../node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__(7245);
// EXTERNAL MODULE: ../../node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(4543);
// EXTERNAL MODULE: ../../node_modules/react-icons/gr/index.esm.js
var gr_index_esm = __webpack_require__(3022);
// EXTERNAL MODULE: ./src/form/Input.module.scss
var Input_module = __webpack_require__(6769);
var Input_module_default = /*#__PURE__*/__webpack_require__.n(Input_module);
;// CONCATENATED MODULE: ./src/form/context.ts

var useFormContext = function() {
    var context = (0,index_esm/* useFormContext */.Gc)();
    if (!context) {
        throw new Error('you must define FormContext to useFormContext');
    }
    return context;
};

;// CONCATENATED MODULE: ./src/form/useClear.ts


function useClear(id) {
    var resetField = useFormContext().resetField;
    var value = (0,index_esm/* useWatch */.qo)({
        name: id
    });
    var clearable = !!value;
    var handleClear = function() {
        return resetField(id);
    };
    return {
        clearable: clearable,
        handleClear: handleClear
    };
};

;// CONCATENATED MODULE: ./src/form/Input.tsx








function Input_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Input_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Input_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Input_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Input_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Input_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var iconValidity = function(invalid, Icon) {
    var Fallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : bi_index_esm/* BiData */.cIE;
    return function IconLabel() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (Input_module_default()).icon,
            children: invalid ? /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiAlertOctagon */.U0j, {
                className: "text-red-500"
            }) : Icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Fallback, {})
        }));
    };
};
function Input(_param) {
    var Icon = _param.Icon, id = _param.id, className = _param.className, inputProps = Input_objectWithoutProperties(_param, [
        "Icon",
        "id",
        "className"
    ]);
    var ref = useFormContext(), register = ref.register, getFieldState = ref.getFieldState;
    var ref1 = useClear(id), showClose = ref1.clearable, handleClear = ref1.handleClear;
    var invalid = getFieldState(id).invalid;
    var InputIcon = iconValidity(invalid, Icon);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseInput, {
        showClear: showClose,
        renderClose: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
            className: (0,clsx_m/* default */.Z)((Input_module_default()).right, (Input_module_default()).top),
            onClear: handleClear
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", Input_objectSpread({
                className: (0,clsx_m/* default */.Z)(inputClass, (Input_module_default()).input, className),
                id: id
            }, inputProps, register(id))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputIcon, {})
        ]
    }));
}
var CloseButton = function(param) {
    var onClear = param.onClear, className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(gr_index_esm/* GrClose */.nfZ, {
        className: (0,clsx_m/* default */.Z)('absolute cursor-pointer z-50', (Input_module_default()).bottom, (Input_module_default()).right, className),
        onClick: onClear
    }));
};
var BaseInput = function(param) {
    var renderClose = param.renderClose, showClear = param.showClear, children = param.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative h-full",
        children: [
            showClear && renderClose,
            children
        ]
    }));
};
function Textarea(_param) {
    var Icon = _param.Icon, id = _param.id, className = _param.className, required = _param.required, inputProps = Input_objectWithoutProperties(_param, [
        "Icon",
        "id",
        "className",
        "required"
    ]);
    var ref = useFormContext(), register = ref.register, getFieldState = ref.getFieldState;
    var ref2 = useClear(id), showClear = ref2.clearable, handleClear = ref2.handleClear;
    var ref3 = getFieldState(id), isInvalid = ref3.invalid;
    var TextareaIcon = iconValidity(isInvalid, Icon, bi_index_esm/* BiMessageSquareDetail */.kK8);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseInput, {
        showClear: showClear,
        renderClose: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
            onClear: handleClear
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", Input_objectSpread({
                id: id,
                className: (0,clsx_m/* default */.Z)(inputClass, (Input_module_default()).input, (Input_module_default()).textarea, 'h-full bg-zinc-200', className),
                required: true
            }, inputProps, register(id, {
                required: required
            }))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextareaIcon, {})
        ]
    }));
}
var inputClass = 'relative rounded border-2 border-gray-300 outline-none font-semibold w-full focus:border-secondary focus:invalid:border-red-500';

;// CONCATENATED MODULE: ./src/form/index.ts




// EXTERNAL MODULE: ./src/components/index.ts + 74 modules
var components = __webpack_require__(9283);
// EXTERNAL MODULE: ../../node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(8799);
// EXTERNAL MODULE: ../../node_modules/react-icons/cg/index.esm.js
var cg_index_esm = __webpack_require__(924);
// EXTERNAL MODULE: ../../node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5186);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(2066);
;// CONCATENATED MODULE: ./src/lib/useSendMessage.ts


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var postContact = function(message) {
    return fetch('/api/contact', {
        method: 'POST',
        body: message,
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        })
    }).then(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(res) {
            var errors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (res.ok) {
                            _ctx.next = 13;
                            break;
                        }
                        if (!/4\d{2}/.test('' + res.status)) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 4;
                        return res.json();
                    case 4:
                        errors = _ctx.sent;
                        _ctx.next = 7;
                        return errors;
                    case 7:
                        throw _ctx.sent;
                    case 10:
                        _ctx.next = 12;
                        return res.text();
                    case 12:
                        throw _ctx.sent;
                    case 13:
                        return _ctx.abrupt("return", res);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(res) {
            return _ref.apply(this, arguments);
        };
    }()).then(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(res) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return res.json();
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(res) {
            return _ref.apply(this, arguments);
        };
    }());
};
function useSendMessage() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var mutation = (0,es.useMutation)('contact', postContact, options);
    return mutation;
};

// EXTERNAL MODULE: ./src/styles/Contact.module.scss
var Contact_module = __webpack_require__(4186);
var Contact_module_default = /*#__PURE__*/__webpack_require__.n(Contact_module);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 27 modules
var esm = __webpack_require__(5849);
;// CONCATENATED MODULE: ./src/pages/contact.tsx









var Contact = function() {
    var ref = useSendMessage(), isLoading = ref.isLoading, isSuccess = ref.isSuccess, isError = ref.isError, mutate = ref.mutate;
    var t = (0,esm/* useTranslation */.$G)('contact').t;
    var submission = function(data) {
        mutate(new URLSearchParams(data));
    };
    var Button = (0,components/* ButtonWithIcon */.Ai)(isLoading ? components/* LoadingSpinner */.TK : bs_index_esm/* BsArrowRight */.lzl);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            isSuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SuccessMessage */.kk, {
                title: t('flash_message.success.title'),
                className: (Contact_module_default()).message,
                children: t('flash_message.success.description')
            }),
            isError && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ErrorMessage */.Bc, {
                title: t('flash_message.failure.title'),
                className: (Contact_module_default()).message,
                children: t('flash_message.failure.description')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                className: (Contact_module_default()).form,
                onSubmit: submission,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Contact_module_default()).fields,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, {
                                id: "name",
                                label: t('fields.name.label'),
                                renderInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    id: "name",
                                    type: "text",
                                    Icon: cg_index_esm/* CgProfile */.Mdg,
                                    placeholder: t('fields.name.placeholder')
                                }),
                                className: (Contact_module_default()).col1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, {
                                id: "email",
                                label: t('fields.email.label'),
                                renderInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    id: "email",
                                    type: "email",
                                    Icon: md_index_esm/* MdAlternateEmail */.g5G,
                                    placeholder: t('fields.email.placeholder')
                                }),
                                className: (Contact_module_default()).col1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, {
                                id: "subject",
                                label: t('fields.subject.label'),
                                renderInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    id: "subject",
                                    type: "text",
                                    placeholder: t('fields.subject.placeholder'),
                                    Icon: md_index_esm/* MdOutlineSubject */.jof
                                }),
                                className: (Contact_module_default()).col1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, {
                                id: "text",
                                label: t('fields.message.label'),
                                required: true,
                                renderInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea, {
                                    id: "text",
                                    placeholder: t('fields.message.placeholder'),
                                    required: true
                                }),
                                className: (Contact_module_default()).col2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        type: "submit",
                        className: (Contact_module_default()).button,
                        disabled: isLoading,
                        children: t('submit')
                    })
                ]
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var contact = (Contact);


/***/ }),

/***/ 6769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"left":"Input_left__4lQWr","icon":"Input_icon__xkCs8","right":"Input_right__QxxFz","textarea":"Input_textarea__vQ2fS","top":"Input_top__i3X70","bottom":"Input_bottom__HPUpJ","input":"Input_input__tNaDr"};

/***/ }),

/***/ 4186:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"Contact_form__VaXHx","message":"Contact_message__cAWKD","title":"Contact_title__2Hc87","typing":"Contact_typing__s0j1H","fields":"Contact_fields__7ippT","col1":"Contact_col1__weAnm","col2":"Contact_col2__9Od_d","button":"Contact_button__Y1MHX"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [424,713,461,955,774,888,179], function() { return __webpack_exec__(9544); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);